<template>
  <DropdownMenu
    button-icon="clock-o"
    :title="menuTitle"
    :button-theme="currentState.buttonTheme"
  >
    <Preloader v-if="savedShiftIsLoading" type="small" />
    <section v-else class="menu__option">
      <label v-if="calendarDates.length > 0" class="option__subtitle">
        Рабочие смены
      </label>
      <ShiftsCalendar :dates="calendarDates" :times="times" />
      <div v-if="hasWorkShiftToday" class="option__block_paragraphs">
        <span v-if="!startTime && !workDayWasCompleted">
          Чтобы начать смену, нажмите на кнопку ниже
        </span>
        <span v-if="startTime">Длительность смены: {{ totalDuration }}</span>
        <span v-if="endTime">Время завершения: {{ endTime }}</span>
        <span v-if="workDayWasCompleted">Рабочий день окончен</span>
      </div>
      <div v-else class="menu__option_without-shift">
        <span>Сегодня у вас нет смены</span>
      </div>
      <div class="option__button">
        <StartButton
          v-if="startTime === null"
          :disabled="workDayWasCompleted || !hasWorkShiftToday"
          @on-start="setStartDate"
        />
        <EndButton
          v-else
          :label="currentState.endButtonLabel"
          :disabled="workDayWasCompleted || !hasWorkShiftToday"
          @on-end="setEndDate"
        />
      </div>
    </section>
  </DropdownMenu>
</template>

<script>
import DropdownMenu from '@/_shared/components/ui/DropdownMenu';
import StartButton from '@/_shared/features/work-shift-menu/StartButton';
import EndButton from '@/_shared/features/work-shift-menu/EndButton';
import ShiftsCalendar from '@/_shared/features/work-shift-menu/ShiftsCalendar';
import Preloader from '@/_shared/components/ui/Preloader';
import { workShiftService } from '@/_shared/api-services';
import { date } from '@/_shared/utils';
import { uiStates } from '@/_shared/constants/work-shift-menu';
import {
  useMenuMessenger, useMenuTimers, useDatesHelper,
} from '@/_shared/mixins/work-shift-menu';
export default {
  mixins: [
    useMenuTimers,
    useMenuMessenger,
    useDatesHelper,
  ],
  components: {
    DropdownMenu,
    StartButton,
    ShiftsCalendar,
    EndButton,
    Preloader,
  },
  data() {
    return {
      savedShiftIsLoading: false,
      startDate: null,
      calendarDates: [],
      times: {},
      endDate: null,
    };
  },
  async created() {
    this.observeTitleTime();
    this.savedShiftIsLoading = true;
    await workShiftService.get().then(({ data }) => {
      if (data.today_shift !== null) {
        this.setEndDate(data.today_shift.end_date);
        this.setStartDate(data.today_shift.start_date);
      }
      if (data.calendar !== null) {
        this.calendarDates = JSON.parse(data.calendar.dates);
        this.times = JSON.parse(data.calendar.times);
      }
      this.hasUnclosedShiftsMessage(data);
      this.savedShiftIsLoading = false;
    });
  },
  computed: {
    menuTitle() {
      const { currentState, titleTime } = this;
      const title = `${currentState.menuTitle} (${titleTime})`;
      return title;
    },
    currentState() {
      if (this.startDate !== null && this.endDate === null) {
        return uiStates.started;
      }
      if (this.endDate !== null) {
        return uiStates.ended;
      }
      return uiStates.pending;
    },
  },
  methods: {
    setEndDate(value) {
      this.endDate = value;
      this.unobserveTotalDuration();
      this.totalDuration = date.getDiffBetweenTwoDates(
        this.startDate, this.endDate,
      );
    },
    setStartDate(value) {
      this.startDate = value;
      this.observeTotalDuration();
    },
  },
};
</script>

<style scoped>
.option__block_paragraphs > span {
  padding-bottom: 1em;
}
.option__block_paragraphs {
  flex-direction: column;
  display: inline-flex;
  padding-top: 1em;
}
.option__block_paragraphs span,
.option__button button {
  text-align: center;
}
.option__button button {
  width: 100%;
}

.option__subtitle {
  margin: 1em 0 0.4em 0;
}
.menu__option_without-shift {
  display: flex;
  justify-content: center;
  padding: 1.2em 0;
}
</style>



// WEBPACK FOOTER //
// src/_shared/widgets/WorkShiftMenu.vue